import React, { Component } from 'react'

import Api from '../../Services/Api';
import CurrentFBO from '../../Services/CurrentFBO';
import NotificationSystem from 'react-notification-system'

import auth from './Auth'

// TODO: add react-notification-system for failed login

export default class LoginForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            password: '',
            message: '',
        };

        this.handleLogin = this.handleLogin.bind(this)
        this.handleSubmitOnEnter = this.handleSubmitOnEnter.bind(this)
    }

    redirectToRoot() {
        this.props.history.push("/")
    }

    redirectToUnauthorized() {
        this.props.history.push('/unauthorized');
    }

    postForm() {
        this.request = Api.get('authenticate', {
            method: "POST",
            body: JSON.stringify({
                email: this.state.email,
                password: this.state.password
            }),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }, false, false).then((response) => {
            if (response.token) {
                console.log(response);
                auth.storeToken(response);
                if (response.fboId) {
                    CurrentFBO.get().then(() => {
                        this.redirectToRoot();
                    }).catch((err) => { console.log(err); });
                } else {
                    this.redirectToUnauthorized();
                }

            } else {
                this.refs.notificationSystem.addNotification({
                    message: "Username and/or Password incorrect.",
                    level: 'error',
                    position: 'tc'
                });
            }
        })
    }

    handleLogin() {
        this.postForm();
    }

    handleSubmitOnEnter(event) {
        if (event.keyCode === 13) {
            this.handleLogin();
        }
    }

    componentWillMount() {
        if (auth.loggedIn()) {
            this.redirectToRoot();
        }
    }

    render() {
        // @TODO This is a placeholder for where this link will go. It can be hidden before customers use the app if the functionality doesn't exist yet or it go be changed to a temporary mailto: link for support to manually get a password rest.
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className="authentication-form">
                    <h1 className="logo">Huvercraft</h1>
                    <div className="form-content">
                        <h4>Login</h4>
                        <input id="email" type="email" placeholder="Email" className="first-child" value={this.state.email}
                            onChange={e => this.setState({ email: e.target.value })}
                            onKeyDown={this.handleSubmitOnEnter}
                            autoFocus />


                        <input id="password" type="password" placeholder="Password" className="last-child"
                            value={this.state.password}
                            onChange={e => this.setState({ password: e.target.value })}
                            onKeyDown={this.handleSubmitOnEnter} />

                        <button type="button" onClick={this.handleLogin} className="btn btn-medium btn-primary">Login</button>
                    </div>
                    <div className="additional-auth-links">
                        <a href="/forgot-password" className="forgot-password">Forgot Password</a>
                        <a href="/signup">Don't have an account? Signup</a>
                    </div>
                </div>
                <div className="spinner hide">
                  <div className="bounce1"></div>
                  <div className="bounce2"></div>
                  <div className="bounce3"></div>
                </div>
            </div>
        );
    }

}

// LoginForm.contextTypes = {
//   router: React.PropTypes.object
// };



// WEBPACK FOOTER //
// ./src/Containers/Authentication/LoginForm.js